// extracted by mini-css-extract-plugin
export var blueBackground = "quote-module--blueBackground--6f147";
export var image = "quote-module--image--d5748";
export var name = "quote-module--name--b1f8b";
export var quote = "quote-module--quote--a907e";
export var quoteWrapper = "quote-module--quoteWrapper--13ef4";
export var textWrapper = "quote-module--textWrapper--10687";